import React from "react";
import { Message } from "components/Atoms/Message";
import { Button } from "semantic-ui-react";
import BrandLogo from "../components/BrandLogo";
import InvitationMessage from "../components/invitation/InvitationMessage";
import InvitationBody from "../components/invitation/personalmessage";
import moment from "moment";
import { formatWrittenDateTimeUtc } from "../utilities";
import OptionsPanel from "components/panels/OptionsPanel";
import { useViewport } from "utilities/hookutils";

interface Props {
  brand: server.dto.BrandSmall

  invitationBody: string
  message: string

  participantCanSign: boolean

  onSignClicked: () => void

  signedUtc: Date

  missingSignatures: string[]

  documentUrl: string
}

const ClientInfoPanel = (props: Props) => {
  const viewport = useViewport();
  const { participantCanSign } = props;

  const isSignedByYou = (props.signedUtc != null);

  return <OptionsPanel>
    <div className="content-section flex-column gap-big">

      <BrandLogo brand={props.brand} boxWhenNoImage />

      <div>
        <InvitationMessage
          message={props.message}
          brandName={props.brand.name}
        />
      </div>

      {props.invitationBody != null && <div><InvitationBody
        message={props.invitationBody}
      /></div>}

      {viewport === "mobile" && <div>
        <Button color="green" fluid size="big" href={props.documentUrl}>
          {RESX.ESign.ViewDocument}
        </Button>
      </div>}

      {!isSignedByYou && participantCanSign && <div>
        <Button color="blue" fluid size="big" onClick={props.onSignClicked}>
          {RESX.ESign.SignThisDocument}
        </Button>
      </div>}

      {isSignedByYou && <div className="flex align-center green-bg white-text padding-large">
        <div className="grow1">
          <div className="margin-bottom-small">
            <h3>
              {RESX.ESign.YouHaveSigned}
            </h3>
          </div>

          <div>
            {formatWrittenDateTimeUtc(moment.utc(props.signedUtc))}
          </div>
        </div>
        <div className="margin-left">
          <i className="icon-check-circle" style={{ fontSize: 45 }} />
        </div>
      </div>}

      <div className="margin-top">
        <Message type="error">
          <div className="margin-bottom">
            <h3>{RESX.ESign.MissingSignature}</h3>
          </div>
          {
            props.missingSignatures.map((name, index) => (<div key={index + name}>{name}</div>))
          }
        </Message>
      </div>
    </div>

  </OptionsPanel >;
};

export default ClientInfoPanel;